import { Row } from 'react-bootstrap';
import FavouriteFomatter from '../../Table/components/formatters/FavouriteFomatter';
import { usePatientProfileSettings } from '../hooks';
import type { PatientProfileTO, PatientTO } from '../../../../lib';

interface ProfileInfoProps {
  profile: PatientProfileTO;
  toggleFavourite?: () => void;
  hasDeidentifiedPermission?: boolean;
}
const PatientInfo = ({
  profile,
  hasDeidentifiedPermission = false,
}: ProfileInfoProps) => {
  const { actionBarGroup, themeStyle } = usePatientProfileSettings();
  return (
    <Row>
      <div className="d-flex align-items-center gap-1">
        {hasDeidentifiedPermission ? (
          <span className="heading1">{profile.access_token}</span>
        ) : (
          <span className="heading1">{`${profile.first_name} ${profile.middle_name ?? ''} ${profile.last_name}`}</span>
        )}
        {!hasDeidentifiedPermission &&
          !actionBarGroup?.showPatientAssignButton && (
            <FavouriteFomatter
              key={`${profile.id}-favourite`}
              id={`${profile.id}-favourite`}
              rowData={profile as unknown as PatientTO}
            />
          )}
      </div>
      {themeStyle === 'AUTOMEDIC' && profile?.clinics[0]?.client_no && (
        <div className="automedic-client-number">
          {profile.clinics[0].client_no}
        </div>
      )}
    </Row>
  );
};

export default PatientInfo;
